import pageStyle from "./index.module.less";
import * as service from "@/views/ticket/service";

export default {
    name: "Log_record",
    data: () => {
        return {
            pageStyle,
            loading: false,
            showAll: false,
            drawer: false,
            page: {
                currentPage: 1,
                pageSize: 10
            },
            tableData: []
        };
    },
    props: {
        value: {
            type: [Object, Array],
            default: () => ({})
        }
    },
    computed: {},
    created() {},
    methods: {
        getQuery() {
            return {
                time_zone: this.value.time_zone,
                open_id: this.value.open_id,
                system_id: this.value.system_id,
                game_id: this.value.game_id,
                ...this.page
            };
        },
        async seeLog(val) {
            if (val == false) {
                this.loading = true;
                const query = this.getQuery();
                const { list } = await service.history(query);
                this.tableData = list;
                this.showAll = true;
                this.loading = false;
            } else {
                this.showAll = false;
                this.page.currentPage = 1;
            }
        },
        handleClose(done) {
            done();
            this.showAll = false;
            this.page.currentPage = 1;
        },
        handlePaginationChange() {
            this.seeLog(false);
        }
    },
    watch: {
        "$i18n.locale"() {
            this.seeLog(false);
        }
    }
};
